import { render, staticRenderFns } from "./CarouselCards.vue?vue&type=template&id=5e1634ce&scoped=true"
import script from "./CarouselCards.vue?vue&type=script&lang=js"
export * from "./CarouselCards.vue?vue&type=script&lang=js"
import style0 from "./CarouselCards.vue?vue&type=style&index=0&id=5e1634ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1634ce",
  null
  
)

export default component.exports